import React, { useState } from 'react';
import { Form, Alert, Spinner } from 'react-bootstrap';
import api from '../../api/axios';

const SOCIAL = [
  { name: 'Facebook', url: 'https://www.facebook.com/share/1Fx2jLVCL4/' },
  { name: 'Instagram', url: 'https://www.instagram.com/monika_jozefowska/' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@monikajozefowska?_r=1&_t=ZN-91WXFDgHrV8' },
];

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await api.post('/contact/', formData);

      setFormData({ name: '', email: '', message: '' });
      setSubmitted(true);

      // Ukryj komunikat po 5 sekundach
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    } catch (error) {
      console.error('Błąd wysyłania formularza kontaktowego:', error);
      setError(error.response?.data?.error || 'Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pub-split" style={{ alignItems: 'start' }}>
      <div>
        <div className="pub-kicker">Kontakt</div>
        <h1 className="pub-h2">Napisz do nas</h1>
        <p className="pub-muted" style={{ marginBottom: 28 }}>
          Masz pytanie o SIGMĘ, cennik albo potrzebujesz faktury? Odpowiemy najszybciej, jak to możliwe.
        </p>

        <div className="pub-card">
          {submitted && (
            <Alert variant="success">
              Dziękujemy! Wiadomość została wysłana. Odpowiemy najszybciej, jak to możliwe.
            </Alert>
          )}

          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="contact-name">
              <Form.Label>Imię</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Jak masz na imię?"
                required
                disabled={loading}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="contact-email">
              <Form.Label>E-mail</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="twoj.email@example.com"
                required
                disabled={loading}
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="contact-message">
              <Form.Label>Wiadomość</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Napisz swoją wiadomość…"
                required
                disabled={loading}
                style={{ resize: 'vertical' }}
              />
            </Form.Group>

            <button type="submit" className="pub-btn" disabled={loading}>
              {loading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                  Wysyłanie…
                </>
              ) : 'Wyślij wiadomość'}
            </button>
          </Form>
        </div>
      </div>

      <div style={{ paddingTop: 8 }}>
        <h2 className="pub-h3">O SIGMIE</h2>
        <p className="pub-muted">
          SIGMA porządkuje urlopy w firmie: pracownicy składają wnioski z telefonu, a pracodawca zatwierdza je
          jednym kliknięciem i widzi pulę dni każdego pracownika.
        </p>
        <h2 className="pub-h3" style={{ marginTop: 32 }}>Znajdziesz nas też tutaj</h2>
        <ul className="pub-list">
          {SOCIAL.map(s => (
            <li key={s.name}>
              <a href={s.url} target="_blank" rel="noopener noreferrer" className="pub-link">{s.name}</a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Contact;
